import { SelectField } from '@mews-commander/form';
import { FormCheckboxField, lt, useFeatureFlag } from '@mews/framework';
import { Option } from '@mews-commander/types';
import { FeatureFlag } from '@mews-commander/enums';
import { Divider } from '@optimus-web/core';
import { PaymentPolicyFieldName, SettlementConfigurationsFieldName } from '../../types';

interface OptionQuery {
    data?: Array<Option>;
    isFetching: boolean;
}

interface PolicyFieldsProps {
    paymentPolicyOptionsQuery: OptionQuery;
    cancellationPolicyOptionsQuery: OptionQuery;
}

export const PolicyFields = ({ paymentPolicyOptionsQuery, cancellationPolicyOptionsQuery }: PolicyFieldsProps) => {
    const requirePaymentDuringOCI = useFeatureFlag(FeatureFlag.requirePaymentDuringOnlineCheckIn);

    return (
        <>
            <SelectField
                autoFocus
                name={PaymentPolicyFieldName.SettlementRules}
                options={paymentPolicyOptionsQuery.data ?? []}
                label={lt('Payment')}
                loader={paymentPolicyOptionsQuery.isFetching}
                multiselect
                required
                overlayMaxHeight={400}
            />
            <SelectField
                name={PaymentPolicyFieldName.CancellationFees}
                options={cancellationPolicyOptionsQuery.data ?? []}
                label={lt('Cancellation')}
                loader={cancellationPolicyOptionsQuery.isFetching}
                multiselect
                overlayMaxHeight={400}
            />
            {requirePaymentDuringOCI && (
                // This was added in policy fields due to UI requirements but it is really a settlement configuration which will allow the user to require payment card during online check-in.
                // Which is why this "option" is being omitted in some parts of the codebase as we don't want to display it in the options list.
                // Hidden under FF for now.
                <>
                    <FormCheckboxField name={SettlementConfigurationsFieldName.RequirePaymentCardDuringOnlineCheckIn}>
                        {lt('CheckInRequirePaymentDetails')}
                    </FormCheckboxField>
                    <Divider />
                </>
            )}
        </>
    );
};
